import { initLightbox } from './modules/lightbox.js';
import { initHeroMobileImage } from './modules/hero-mobile-image.js';

document.addEventListener('DOMContentLoaded', () => {
  initLightbox();
  initHeroMobileImage();
});
